import API from "@utils/plugins/API";

const AuthorizationTypeService = {
  all: (params) => {
    return API.get("authorization-types", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("authorization-types", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`authorization-types/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`authorization-types/${id}`);
  },
  destroy: (id) => {
    return API.delete(`authorization-types/${id}`);
  },
};

export default AuthorizationTypeService;
